<div class="box" [style.background-image]="'url(' + bgImg + ')'">
    <div class="itax-body">
        <div class="container position-relative w-100 h-100">
            <div class="row d-flex justify-content-center">
                <div class="col-12">
                    <div class="h2 w-100 text-center mb-10px">iTAX {{year}} คืออะไร</div>
                    <div class="p2 text-center sub-text mb-20px text-gray-medium">
                        iTAX {{year}} เทศกาลลดหย่อนภาษีประจำปี
                        เกิดขึ้นเพื่อเปิดพื้นที่ให้ผู้เสียภาษีสามารถรักษาสิทธิประโยชน์ของตัวเองอย่างเต็มที่โดยไม่จำเป็นต้องรู้ภาษีและไม่มีค่าใช้จ่าย
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
